import {
  Flex,
  Stack,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { CheckCircleOIcon, ClockIcon } from '@tonic-one/react-icons';
import { t } from 'i18next';
import { MitigationType } from '../../types/remediation';

interface MitigationProgressProps {
  mitigationType: MitigationType;
  mitigationProgress: number;
  analysisResult?: string;
}

export const MitigationHeader = ({
  mitigationType,
  mitigationProgress,
  analysisResult,
}: MitigationProgressProps) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const getTitle = () => {
    const lowerResult = analysisResult?.toLowerCase() || '';
    if (lowerResult === 'flagged') {
      return t('operations.euq.mitigation.actions');
    }
    if (mitigationType === MitigationType.AUTOMATIC) {
      return t('operations.euq.mitigation.automaticAction');
    }
    return t('operations.euq.mitigation.mitigationActions');
  };

  return (
    <Stack gap="2x">
      <Flex alignItems="center" columnGap="2x">
        {mitigationProgress === 100 ? (
          <CheckCircleOIcon size="4x" color={colorStyle.color.success} />
        ) : (
          <ClockIcon size="4x" />
        )}
        <Text size="lg" fontWeight={500}>
          {getTitle()}
        </Text>
      </Flex>
      <Text color={colorStyle.color.secondary}>
        {mitigationType === MitigationType.AUTOMATIC
          ? t('operations.euq.mitigation.auto.description')
          : t('operations.euq.mitigation.manual.description')}
      </Text>
    </Stack>
  );
};
